import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgWrite = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M16.763 2.677a1.75 1.75 0 0 1 2.474 0l2.086 2.086a1.75 1.75 0 0 1 0 2.474L13.53 15.03a.75.75 0 0 1-.367.202l-4.5 1a.75.75 0 0 1-.895-.895l1-4.5a.75.75 0 0 1 .202-.367zm1.414 1.06a.25.25 0 0 0-.354 0l-.762.763L19.5 6.94l.763-.763a.25.25 0 0 0 0-.354zM18.439 8 16 5.56l-5.815 5.816-.697 3.136 3.136-.697zM4 3.75a.25.25 0 0 0-.25.25v16c0 .138.112.25.25.25h16a.25.25 0 0 0 .25-.25v-5.5a.75.75 0 0 1 1.5 0V20A1.75 1.75 0 0 1 20 21.75H4A1.75 1.75 0 0 1 2.25 20V4c0-.967.784-1.75 1.75-1.75h6a.75.75 0 0 1 0 1.5z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgWrite;
